import type { ReactNode } from 'react';

/**
 * Шапка экранов вне кабинета: вход и выбор вакансии. Слева щит + «Портал сотрудников»
 * (в industrial — одной строкой капсом), справа — children.
 */
export default function PortalTopBar({ industrial, children }: { industrial: boolean; children?: ReactNode }) {
  return (
    <header className="flex items-center justify-between px-8 py-4 border-b border-surface-3 relative z-10">
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-primary-500/30 to-transparent" />
      {industrial ? (
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg flex items-center justify-center bg-primary-500">
            <i className="ri-shield-user-line text-xl text-on-primary" />
          </div>
          <span className="hidden sm:block font-heading text-sm font-extrabold uppercase tracking-[0.06em] text-ink">
            Портал сотрудников
          </span>
        </div>
      ) : (
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl flex items-center justify-center bg-primary-500/10 border border-primary-500/20">
            <i className="ri-shield-user-line text-xl text-primary-300" />
          </div>
          <div className="hidden sm:flex flex-col leading-tight">
            <span className="text-[11px] text-foreground-500 tracking-widest uppercase">Корпоративный</span>
            <span className="text-sm font-semibold text-ink tracking-wide">Портал сотрудников</span>
          </div>
        </div>
      )}
      {children}
    </header>
  );
}
